import { apiInterfaceForJson } from '../common/apiManager';

export const fetchQcSamples = (showArchived = false) => {
    return apiInterfaceForJson(`/qcSample/v1/?showArchived=${showArchived}`, 'GET');
};

export const getQcSampleDataById = (qcSampleId) => {
    return apiInterfaceForJson('/qcSample/v1/' + qcSampleId, 'GET');
};

export const searchQcSamples = (filter) => {
    return apiInterfaceForJson('/qcSample/v1/search', 'POST', filter);
};

export const createQcSample = (qcSampleDetails) => {
    return apiInterfaceForJson('/qcSample/v1/', 'POST', qcSampleDetails);
};

export const printBarcodes = (qcSamples) => {
    return apiInterfaceForJson('/qcSample/v1/printBarcodes', 'POST', qcSamples);
};

export const updateQcSample = (qcSampleDetails) => {
    return apiInterfaceForJson('/qcSample/v1/', 'PUT', qcSampleDetails);
};

export const deleteQcSample = (qcSampleDetails) => {
    return apiInterfaceForJson('/qcSample/v1/delete', 'POST', qcSampleDetails);
};
